import type { AuthError } from 'firebase/auth'

export function isFirebaseAuthError(err: unknown): err is AuthError {
	return typeof err === 'object' && err !== null && 'code' in err && typeof (err as AuthError).code === 'string'
}

/** Mensaje en español para errores de sign-in / sign-out (códigos Firebase Auth). */
export function getAuthErrorMessageSpanish(err: unknown): string {
	if (!isFirebaseAuthError(err)) {
		return 'Ocurrió un error. Intenta de nuevo.'
	}
	switch (err.code) {
		case 'auth/user-not-found':
			return 'No existe una cuenta con este correo electrónico'
		case 'auth/wrong-password':
			return 'La contraseña es incorrecta'
		case 'auth/invalid-credential':
			return 'Correo o contraseña incorrectos'
		case 'auth/invalid-email':
			return 'El correo electrónico no es válido'
		case 'auth/user-disabled':
			return 'Esta cuenta ha sido deshabilitada'
		case 'auth/too-many-requests':
			return 'Demasiados intentos. Por favor, espera un momento antes de intentar nuevamente'
		case 'auth/network-request-failed':
			return 'Error de red. Comprueba tu conexión e intenta de nuevo'
		case 'auth/invalid-verification-code':
			return 'El código de verificación no es válido. Intenta de nuevo.'
		case 'auth/code-expired':
			return 'El código expiró. Genera uno nuevo en tu app de autenticación.'
		case 'auth/unverified-email':
			return 'Debes verificar tu correo electrónico antes de usar este paso de seguridad.'
		case 'auth/requires-recent-login':
			return 'Por seguridad, vuelve a iniciar sesión con tu contraseña e intenta de nuevo.'
		default:
			return 'No se pudo iniciar sesión. Intenta de nuevo.'
	}
}

/** Errores típicos al enviar correo de recuperación (misma API, mensajes adaptados). */
export function getPasswordResetErrorMessageSpanish(err: unknown): string {
	if (!isFirebaseAuthError(err)) {
		return 'No se pudo enviar el correo. Intenta de nuevo.'
	}
	switch (err.code) {
		case 'auth/invalid-email':
			return 'El correo electrónico no es válido'
		case 'auth/missing-email':
			return 'Ingresa un correo electrónico'
		case 'auth/too-many-requests':
			return 'Demasiados intentos. Espera un momento e intenta de nuevo'
		case 'auth/network-request-failed':
			return 'Error de red. Comprueba tu conexión e intenta de nuevo'
		default:
			return 'No se pudo enviar el correo. Intenta de nuevo.'
	}
}
